import React from 'react';
import {InputCheckbox} from '..';
import {Trash, Save} from '../../assets/icons/icons';
import {ActiveLink, ActiveButton, ActiveText} from './styles';

export default ({
  path,
  icon,
  text,
  title,
  counter,
  xmargin,
  onClick,
}: {
  title: string;
  path?: string;
  icon?: string;
  text?: string;
  onClick?: any;
  counter?: number;
  xmargin?: string;
}) =>
  path ? (
    <ActiveLink end style={(navData) => (navData.isActive ? {color: '#fff', backgroundColor: '#acb1c0'}: {})} to={path} xmargin={xmargin} onClick={onClick}>
      {title}
    </ActiveLink>
  ) : (
    <ActiveButton xmargin={xmargin} onClick={onClick}>
      {icon === 'trash' ? (
        <Trash />
      ) : icon === 'save' ? (
        <Save color={'#ACB1C0'} />
      ) : icon === 'checkbox' ? (
        <InputCheckbox xmargin="0" checked={true} />
      ) : (
        title
      )}
      {counter ? <ActiveText>({counter})</ActiveText> : text ? <ActiveText>{text}</ActiveText> : <></>}
    </ActiveButton>
  );
